import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMaintenance: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMaintenance"><Path d="M22 9.5C22 13.6421 18.6421 17 14.5 17C13.4668 17 12.4824 16.7911 11.5868 16.4132L6 22L2 18L7.5868 12.4132C7.20891 11.5176 7 10.5332 7 9.5C7 5.35786 10.3579 2 14.5 2C15.7996 2 17.0221 2.33057 18.0878 2.91221L14 7C13.1716 7.82843 13.1716 9.17157 14 10C14.8284 10.8284 16.1716 10.8284 17 10L21.0878 5.91221C21.6694 6.97793 22 8.20036 22 9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMaintenance;
